import { ApiExplorerInput } from '@squareup/dex-types-shared-api-explorer';
import { Merchant } from '@squareup/dex-types-shared-developer-data-api';

interface PrefillScenario {
  endpointId: string;
  scenario: ApiExplorerInput;
}

/**
 * Return the merchant currency code if it is a supported country for payment,
 * otherwise return USD.
 * @param merchant Current authenticated merchant
 * @returns currency code
 */
const getPrefillCurrency = (merchant: Merchant | undefined) => {
  if (
    merchant &&
    ['GB', 'CA', 'US', 'JP', 'IE', 'FR'].includes(merchant.country)
  ) {
    return merchant.currency;
  }
  return 'USD';
};

const getPrefillScenarios = (
  currency: string
): Record<string, PrefillScenario> => ({
  'create-payment': {
    endpointId: 'create-payment',
    scenario: {
      bodyParameters: {
        amount_money: {
          amount: 100,
          currency,
        },
        idempotency_key: crypto.randomUUID(),
        source_id: 'cnon:card-nonce-ok',
      },
      queryParameters: {},
      pathParameters: {},
      authParameters: {},
      fileParameters: {},
    },
  },
});

/**
 * Generates a prefill scenario object that will map data to fields
 * in the API Explorer
 * @param key The hyphenated name of the prefill scenario to use
 * @param endpointId The id of the endpoint that this prefill is being requested for
 * @param merchant Current authenticated merchant
 * @returns The prefill object, if it exists. Otherwise `undefined`
 */
const lookupPrefill = (
  key: string,
  endpointId: string,
  merchant: Merchant | undefined
) => {
  const prefillScenarios = getPrefillScenarios(getPrefillCurrency(merchant));
  if (key in prefillScenarios) {
    const prefill = prefillScenarios[key as keyof typeof prefillScenarios];
    if (prefill?.endpointId === endpointId) {
      return prefill?.scenario;
    }
  }
  return undefined;
};

export { lookupPrefill };
